import axios from 'axios';

export default {
  pre_insercion_pol_nue(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_compp_gesven.pre_insercion_pol_nue",
				"p_args_in": JSON.stringify({
          "p_usuario": p_usuario
				})
			})
	},

	recuperar_pol_nue(p_email, p_usuario, p_ano, p_poliza, p_ejecutivo, p_corredor, p_producto, p_contratante){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_gesven.recuperar_pol_nue",
			"p_args_in": JSON.stringify({
			"p_usuario": p_usuario,
			"p_ano": p_ano,
			"p_poliza": p_poliza,
			"p_ejecutivo": p_ejecutivo,
			"p_corredor": p_corredor,
			"p_producto": p_producto,
			"p_contratante": p_contratante
				})
		})
	},

  consulta_poliza(p_email, p_ejecutivo, p_poliza){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_gesven.fnc_consultaPoliza",
			"p_args_in": JSON.stringify({
				"p_ejecutivo": p_ejecutivo,
				"p_poliza": p_poliza,
			  })
		})
	},

	consulta_contratante(p_email, p_contratante){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_gesven.fnc_consultacontratante",
			"p_args_in": JSON.stringify({
				"p_contratante": p_contratante,
				})
		})
	},

	consulta_corredor(p_email, p_corredor){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_gesven.fnc_consultaCorredor",
			"p_args_in": JSON.stringify({
				"p_codcorredor": p_corredor,
				})
		})
	},


  actualiza_eje_pri_cto(p_email, p_usuario, p_poliza, p_eje1er, p_ejecierre, p_obs, p_relacionada){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_gesven.actualiza_eje_pri_cto",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_poliza": p_poliza,
				"p_eje1er": p_eje1er,
				"p_ejecierre": p_ejecierre,
				"p_obs": p_obs,
        		"p_relacionada": p_relacionada
				})
		})
	},

  pre_insercion_inc_raz_soc(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_compp_gesven.pre_insercion_inc_raz_soc",
				"p_args_in": JSON.stringify({
          			"p_usuario": p_usuario
					})
			})
	},

	recuperar_inc_raz_soc(p_email, p_usuario, p_ano, p_poliza, p_ejecutivo, p_corredor, p_producto, p_contratante){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_gesven.recuperar_inc_raz_soc",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_ano": p_ano,
				"p_poliza": p_poliza,
				"p_ejecutivo": p_ejecutivo,
				"p_corredor": p_corredor,
				"p_producto": p_producto,
				"p_contratante": p_contratante
				})
		})
	},

  actualiza_inc_raz_soc(p_email, p_usuario, p_poliza, p_obs, p_asegurado){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_gesven.actualiza_inc_raz_soc",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_poliza": p_poliza,
				"p_obs": p_obs,
				"p_asegurado": p_asegurado
				})
		})
	},

}
